const KST_OFFSET_MS = 9 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

const toKstDate = (value) => new Date(value.getTime() + KST_OFFSET_MS).toISOString().slice(0, 10);

export const buildSportsbookHistoryQuery = ({
  dateRange,
  customStartDate,
  customEndDate,
  status,
  category,
  now = new Date(),
}) => {
  const today = toKstDate(now);
  const query = {};

  if (dateRange === 'all') {
    query.all_time = true;
  } else if (dateRange === 'today') {
    query.start_date = today;
    query.end_date = today;
  } else if (dateRange === '7days') {
    query.start_date = toKstDate(new Date(now.getTime() - 6 * DAY_MS));
    query.end_date = today;
  } else if (dateRange === '30days') {
    query.start_date = toKstDate(new Date(now.getTime() - 29 * DAY_MS));
    query.end_date = today;
  } else if (dateRange === 'custom') {
    query.start_date = customStartDate || today;
    query.end_date = customEndDate || today;
  }

  if (status) query.status = status;
  if (category) query.category = category;
  return query;
};

export const sportsbookHistoryRowMatchesQuery = (row, query) => {
  if (query.status && row.status !== query.status) return false;
  if (query.category && row.category !== query.category) return false;
  if (!query.start_date && !query.end_date) return true;
  const acceptedAt = new Date(row.accepted_at);
  if (!Number.isFinite(acceptedAt.getTime())) return false;
  const acceptedDate = toKstDate(acceptedAt);
  if (query.start_date && acceptedDate < query.start_date) return false;
  if (query.end_date && acceptedDate > query.end_date) return false;
  return true;
};
